import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import {Container,CssBaseline,
    Grid,Button,Paper } from '@material-ui/core';
import omit from 'lodash/omit';
// import moment from 'moment';
import { useHistory,useParams,useLocation } from 'react-router-dom';

import { AppContext } from '../../App';
import axios from '../../utils/axios';
import util from '../../utils/util';

import validate from '../../utils/validate';
import constraint from '../../Constraints/Operation';
import MyTextField from '../Codification/MyTextField';
import MyDateField from '../Codification/MyDateField';
import MySelectField from '../Codification/MySelectField';

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }, 
}))
const initData = {
    date_operation:"",
    type_operation:"",
    numero_compte:"",
    errors:{}
};
export default function Operation(){
    const classes = useStyles();
    const history = useHistory();
    const { id } = useParams()
    const appContext = React.useContext(AppContext);
    const [operation,setOperation] = React.useState({...initData})
    const [typeOperations,setTypeOperations] = React.useState([])
    const [numeroComptes,setNumeroComptes] = React.useState([])
    const [view,setView] = React.useState(false);
    const { pathname } = useLocation();
    const fetchData = async ()=>{
        appContext.setOpenLoading(true);
        try {
            const [typeOperations,numeroComptes] = await Promise.all([
                axios.get(`/type-operations`),
                axios.get(`/numero-comptes`),
            ]);
            if(id){
                const {data} = await axios.get(`/operations/${id}`);
                let operation = {
                        id: data.id,
                        date_operation:data.date_operation,
                        type_operation:data.type_operation.id,
                        numero_compte:data.numero_compte.id,
                        montant:data.montant,
                        description: data.description,
                        errors:{}
                    }
                if(pathname===`/operations/view/${id}`){
                    setView(true);
                    operation = {
                        ...operation,
                        type_operation:data.type_operation,
                        numero_compte:data.numero_compte
                    }
                }
                setOperation(operation)
            }
            setTypeOperations(typeOperations.data.results)            
            setNumeroComptes(numeroComptes.data.results)            
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }
        appContext.setOpenLoading(false);
    }

    React.useEffect(()=>{
        fetchData();
        // eslint-disable-next-line
    },[]);
    const handleChange = (e)=>{
        setOperation({...operation,[e.target.name]:e.target.value})
    }
    const enregistrer = async (nouveau)=>{
        const errors = validate(operation,constraint.add);
        if(errors){
            setOperation({...operation,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.post(`/operations`,{...omit(operation,['errors','prestataire'])});
            appContext.addMessage('Enregistrement effectué avec succès','success');
            if(nouveau){
                setOperation({...initData})
            }else{
                history.push("/liste-operations")
            }
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    const modifier = async ()=>{
        const errors = validate(operation,constraint.add);
        if(errors){
            setOperation({...operation,errors});
            return;
        }
        try {
            appContext.setOpenLoading(true);
            await axios.put(`/operations/${operation.id}`,{...omit(operation,['errors'])});
            appContext.addMessage('Modification effectué avec succès','success');
            history.goBack()
        } catch (error) {
            console.log(error,error.response);
            appContext.addMessage(util.getContentError(error),'error');
        }    
        appContext.setOpenLoading(false);
    }
    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <Paper className={classes.paper}>

                <Typography variant="h5" gutterBottom>
                    {id ? "Modification" : "Saisie"} Opération
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <MyDateField 
                            name="date_operation"
                            value={operation.date_operation||""}
                            onChange={handleChange}
                            errors={operation.errors}
                            label="Date operation"
                            disabled={view}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {view ?
                            <MyTextField 
                                name="type_operation"
                                value={operation.type_operation && operation.type_operation.libelle}
                                label="Type opération"
                                disabled={view}
                                required={false}
                            />
                        :
                            <MySelectField 
                                name="type_operation"
                                value={operation.type_operation}
                                onChange={handleChange}
                                errors={operation.errors}
                                options={typeOperations}
                                libelle="libelle"
                                disabled={view}
                                label="Type opération"
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {view ?
                            <MyTextField 
                                name="numero_compte"
                                value={operation.numero_compte && operation.numero_compte.libelle}
                                label="Numéro compte"
                                disabled={view}
                                required={false}
                            />
                        :
                            <MySelectField 
                                name="numero_compte"
                                value={operation.numero_compte}
                                onChange={handleChange}
                                errors={operation.errors}
                                options={numeroComptes}
                                libelle="libelle"
                                disabled={view}
                                label="Numéro compte"
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                            }}
                            name="description"
                            value={operation.description}
                            onChange={handleChange}
                            errors={operation.errors}
                            label="Description de la operation"
                            multiline
                            rows="4"
                            variant="outlined"
                            disabled={view}
                            required={false}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <MyTextField 
                            inputProps={{
                                min:"0",
                                style:{textAlign:'right'}
                            }}
                            name="montant"
                            type={view?"text":"number"}
                            value={view ? util.separteurMillier(operation.montant):operation.montant}
                            onChange={handleChange}
                            errors={operation.errors}
                            label="Montant du operation"
                            disabled={view}
                            // style={{}}
                        />
                    </Grid>
                    {id ?
                        <Grid item xs={12} sm={12}>
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                                onClick={view?history.goBack:modifier}
                            >
                                {view ?'Retour':'Modifier'}
                            </Button>
                        </Grid>
                        :
                        <Grid container>
                            <Grid item xs={6} sm={6} style={{display:'flex', justifyContent:'center'}}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(true)}
                                >
                                    Enregistrer & Nouveau
                                </Button>
                            </Grid>
                            <Grid item xs={6} sm={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={()=>enregistrer(false)}
                                >
                                    Enregistrer & Quitter
                                </Button>
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Paper>
        </Container>
    )
};